module.exports = __webpack_public_path__ + "img/contact.098f1e2b.png";